import {
  vArray,
  vEmail,
  vObject,
  type vOutput,
  vPicklist,
} from '../validation/index.ts'

export const loadNotificationTypes = [
  'shipment',
  'tender',
  'exception',
  'estimated-delivery',
  'delivery',
] as const

export type LoadNotificationType = (typeof loadNotificationTypes)[number]

export const loadNotificationSchema = vObject({
  email: vEmail,
  notificationTypes: vArray(vPicklist(loadNotificationTypes)),
})

export type LoadNotificationDto = vOutput<typeof loadNotificationSchema>
